import { StateCreator } from 'zustand';

import {
  handleClearLabelsByEmailAddress,
  handleCreateLabel,
  handleDeleteLabel,
  handleGetLabelByIdAndEmailAddress,
  handleGetLabelNameFromLabelIdsArray,
  handleSetInboxLabels,
  handleSetLoadingFetchLabels,
  handleUpdateLabel,
} from './handlers';
import { INITIAL_LABELS_STATE, LabelsStore } from './types';

export const createLabelsSlice: StateCreator<LabelsStore> = (set, get) => {
  return {
    ...INITIAL_LABELS_STATE,
    setInboxLabels: (labels) => handleSetInboxLabels(set, labels),
    setLoadingFetchLabels: (isLoading) =>
      handleSetLoadingFetchLabels(set, isLoading),
    getLabelByIdAndEmailAddress: (id, emailAddress) =>
      handleGetLabelByIdAndEmailAddress(get, id, emailAddress),
    updateLabel: (id, emailAddress, data) =>
      handleUpdateLabel(set, id, emailAddress, data),
    deleteLabel: (id) => handleDeleteLabel(set, id),
    createLabel: (data, parentId) => handleCreateLabel(set, data, parentId),
    getLabelNameFromLabelIdsArray: (emailAddress, array) =>
      handleGetLabelNameFromLabelIdsArray(get, emailAddress, array),
    clearLabelsByEmailAddress: (emailAddress) =>
      handleClearLabelsByEmailAddress(set, emailAddress),
    resetState: () => set(INITIAL_LABELS_STATE),
  };
};
